import { Button, Modal } from "react-ui";
import * as React from "react";

import { DescriptionList, DescriptionName, DescriptionTerm } from "./FnsRequirementsModal.styles";

interface FnsRequirementsModalProps {
    onClose: () => void;
}

export function FnsRequirementsModal(props: FnsRequirementsModalProps): JSX.Element {
    return (
        <Modal width={500} onClose={props.onClose}>
            <Modal.Header>{"Требования ФНС к изображениям"}</Modal.Header>
            <Modal.Body>
                <DescriptionList>
                    <DescriptionName>Цветность</DescriptionName>
                    <DescriptionTerm>Черно-белое, 256 градаций серого</DescriptionTerm>
                    <DescriptionName>Разрешение</DescriptionName>
                    <DescriptionTerm>150 — 300 точек на дюйм</DescriptionTerm>
                </DescriptionList>
            </Modal.Body>
            <Modal.Footer panel>
                <Button size="medium" use="primary" onClick={props.onClose}>
                    Закрыть
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
